import { spanish } from "../context/lang/langs/spanishMessages";
import { english } from "../context/lang/langs/englishMessages";

export enum LangPaths {
  EN = "en",
  ES = "es",
}

export const langInit = () => {
  const lang = document.documentElement.lang;

  switch (lang) {
    case LangPaths.ES:
      return { ...spanish };
    default:
      return { ...english };
  }
};

export const findLangPath = (location: Location) => {
  const path = location?.pathname;
  const lang = path.split("/")[1]?.split("/")[0];
  return lang || LangPaths.EN;
};

export const navigateWithLang = (lang: LangPaths, location: Location) => {
  const path = location.pathname;
  if (path === "/") return lang;
  const newPath = path.replace(findLangPath(location), lang);
  return newPath;
};

export const languages = [
  {
    name: "English",
    code: LangPaths.EN,
    shortName: "en",
  },
  {
    name: "Español",
    code: LangPaths.ES,
    shortName: "es",
  },
];
